import React, { useEffect, useState } from "react";
import { noticount, notilist, notistatus, pushnotilist } from "../../../services/admin";
import moment from "moment";
import { AgGridReact } from "ag-grid-react";
import { useLocation } from "react-router-dom";
export default function Notificationlist() {
  const [path, setPath] = useState("");
  const [filePath, setFilePath] = useState("");
  const [filterProduct, setFilterProduct] = useState([]);
  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage] = useState(10); // Number of records to show per click

  const totalRecordsToShow = currentPage * recordsPerPage;
  const currentRecords = filterProduct.slice(0, totalRecordsToShow);

  const loadMore = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  function listall() {
    setLoading(true);
    setFilterProduct([]);
    const temp = new FormData();
    const academyId = localStorage.getItem("AAcademy") || localStorage.getItem("academy") || "";
    if (academyId) temp.append("academy_id", academyId);
    if (
      localStorage.getItem("Role") === "1" ||
      localStorage.getItem("Role") === "2"
    ) {
      notilist(temp).then((res) => {
        if (res.status === true) {
          setFilePath(res.data.path || "");
          if (res.data.details.length > 0) {
            const cdata = res.data.details.map((item) => {
              return {
                ...item,
                created_at: moment(item.created_at).format("DD-MM-YYYY"),
                time: moment(item.created_at).format("hh:mm A"),
                sent_role: item.noti_sent_role == 0
                  ? " Sent to All"
                  : ` Sent to ${item.role}`
              };
            });
            setFilterProduct(cdata);
          }
          setLoading(false);
        }
      });
    } else {
      notilist(temp).then((res) => {
        if (res.status === true) {
          setFilePath(res.data.path || "");
          setFilterProduct(res.data.details);
          setLoading(false);
        }
      });
      // noticount().then((res) => {
      //   if (res.status === true) {
      //     setFilterProduct(res.data.details);
      //     setLoading(false);
      //   }
      // });
    }
    // changestatus(0,0);
  }

  function pushlistall(ltype) {
    setLoading(true);
    setFilterProduct([]);
    if (
      localStorage.getItem("Role") === "1" ||
      localStorage.getItem("Role") === "2"
    ) {
      pushnotilist(ltype).then((res) => {
        if (res.status === true) {
          // setFilterProduct(res.data.details);
          if (res.data.details.length > 0) {
            const cdata = res.data.details.map((item) => {
              return {
                ...item,
                created_at: moment(item.created_at).format("DD-MM-YYYY"),
                time: moment(item.created_at).format("hh:mm A"),
                sent_role: item.noti_sent_role == 0
                  ? " Sent to All"
                  : ` Sent to ${item.role}`
              };
            });
            setFilterProduct(cdata);
          }
          setLoading(false);
        }
      });
    } else {
      pushnotilist().then((res) => {
        if (res.status === true) {
          setFilterProduct(res.data.details);
          setLoading(false);
        }
      });
      // noticount().then((res) => {
      //   if (res.status === true) {
      //     setFilterProduct(res.data.details);
      //     setLoading(false);
      //   }
      // });
    }
    // changestatus(0,0);
  }
  function changestatus(eid, etype) {
    if (
      localStorage.getItem("Role") === "1" ||
      localStorage.getItem("Role") === "2"
    ) {
    } else {
      if (etype == 0) {
        setFilterProduct([]);

        notistatus(eid).then((res) => {
          if (res.status === true) {
            listall();
          }
        });
      }
    }
  }
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname.split('/')[1];
    setPath(path);
    if (path === "attendance") {
      pushlistall(path);
    } else {
      listall();
    }
  }, [location]);

  const columnDefs = [

    {
      headerName: "Title",
      field: "title",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Date",
      field: "created_at",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Time",
      field: "time",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Message",
      field: "message",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Message Sent To",
      field: "sent_role",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },

    {
      headerName: "Academy",
      field: "academy_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Attachment",
      field: "noti_file",
      sortable: false,
      resizable: true,
      filter: false,
      cellRenderer: (params) => {
        if (!params.value) return "";
        const url = `${filePath}${params.value}`;
        return <div >
          <a href={url} target="_blank" rel="noreferrer" title="View" className="btn-sm btn-info me-2">
            <i className="fa fa-eye"></i>
          </a>
          <a href={url} download title="Download" className="btn-sm btn-success">
            <i className="fa fa-download"></i>
          </a>
        </div>;
      },
      cellStyle: { textAlign: "left" },
      width: 110,
    },
  ];

  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">{path == "attendance" ? "Attendance Notification" : "Circular"} List</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>{path == "attendance" ? "Attendance" : "Circular"}</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            {path == "attendance" ? "Attendance Notification" : "Circular"} List
          </li>
        </ol>
      </div>
      {loading && (
        <div className="loader-wrapper">
          <div className="loader"></div>
          <h3>Loading...Please do not go back or close the window.</h3>
        </div>
      )}
      {!loading && localStorage.getItem("Role") <= 2 && (
        <div className="container">
          <div className="ag-theme-alpine ag-style mt-2">
            <AgGridReact
              columnDefs={columnDefs}
              rowData={filterProduct}
              pagination="true"
              paginationPageSize="10"
              sortingOrder={["asc", "desc"]}
              suppressDragLeaveHidesColumns={true}
            />
          </div>
        </div>
      )

      }
      {!loading && localStorage.getItem("Role") > 2 && (
        <div className="container">
          <ul className="notification">
            {currentRecords.length > 0 && currentRecords.map((item) => {
              return (
                <li>
                  <div className="notification-time">
                    <span className="date">
                      {moment(item.created_at).format("DD MMM")}
                    </span>
                    <span className="time">
                      {" "}
                      {moment(item.created_at).format("hh:mm A")}
                    </span>
                  </div>

                  <div className="notification-time-date mb-2 d-block d-md-none">
                    <span className="date">
                      {moment(item.created_at).format("DD MMM")}
                    </span>
                    <span className="time">
                      {" "}
                      {moment(item.created_at).format("hh:mm A")}
                    </span>
                  </div>
                  <div
                    className={
                      item.notification_read == 0
                        ? "notification-body-active"
                        : "notification-body"
                    }
                    onClick={() => changestatus(item.id, item.notification_read)}
                  >
                    <div className="media mt-0">
                      <div className="main-avatar avatar-md offline">

                      </div>
                      <div className="media-body ms-3 d-flex">
                        <div className="">
                          <p className="tx-14 text-dark mb-0 tx-semibold">
                            {item.title}
                            {(localStorage.getItem("Role") === "1" ||
                              localStorage.getItem("Role") === "2") &&
                              <span className="text-danger">
                                {item.noti_sent_role == 0
                                  ? " (Sent to All)"
                                  : ` (Sent to ${item.role})`}{" "}
                              </span>
                            }

                          </p>
                          <p className="mb-0 tx-13 text-muted">{item.message}</p>
                          {item.noti_file && (
                            <div className="mt-2 d-flex gap-2">
                              <a
                                href={`${filePath}${item.noti_file}`}
                                target="_blank"
                                rel="noreferrer"
                                title="View Attachment"
                                className="btn btn-sm btn-primary"
                                style={{ padding: "4px 10px" }}
                              >
                                <i className="fa fa-eye me-1"></i> View
                              </a>
                              <a
                                href={`${filePath}${item.noti_file}`}
                                download
                                title="Download Attachment"
                                className="btn btn-sm btn-success"
                                style={{ padding: "4px 10px" }}
                              >
                                <i className="fa fa-download me-1"></i> Download
                              </a>
                            </div>
                          )}
                        </div>
                        <div className="notify-time">
                          <p className="mb-0 text-muted tx-11">
                            {moment(item.created_at).format("hh:mm A")}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              );
            })}
            {currentRecords.length == 0 && (
              <div className="text-center">
                <h4 className=" text-danger">No Notification Found</h4>
              </div>
            )}
          </ul>
          {totalRecordsToShow < filterProduct.length && (
            <div className="text-center mb-4">
              <a onClick={loadMore} className="btn btn-success w-md">
                Load More
              </a>
            </div>
          )}
        </div>
      )

      }

    </div>
  );
}
